import { FC, SVGProps } from 'react'

export const History: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.3335 7.99992C1.3335 11.3136 4.00016 14.6666 8.00016 14.6666C12.0002 14.6666 14.6668 11.9999 14.6668 7.99992C14.6668 3.99992 12.0002 1.33325 8.00016 1.33325C4.00016 1.33325 1.3335 4.66659 1.3335 4.66659M1.3335 4.66659V1.99992M1.3335 4.66659H3.66683"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00024 5.33325V7.99992L10.0002 9.33325"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
